import { request } from "@umijs/max";

// 登录
export async function loginApi(options?: { [key: string]: any }) {
  return request<any>('/api/v1/emp/manage/auth/login', {
    method: 'POST',
    data: {
      ...(options || {}),
    },
  });
}

// 获取当前应用信息
export async function querryCurrentUserApi() {
  return request<any>('/api/v1/emp/manage/auth/info', {
    method: 'GET',
  });
}
